export const shipperAdminChatName = (chatId: number) => `private-loads-chat-${chatId}`
export const adminAdminChatName = (loadId: number) => `private-loads-${loadId}`
